import { useEffect, useState } from 'react'
import type { ChecklistItem } from '../types/schema'
import { subscribeChecklistItemsView } from '../services/checklistReader'

export function useWorkspaceChecklistItems(workspaceId?: string | null): ChecklistItem[] {
  const [items, setItems] = useState<ChecklistItem[]>([])

  useEffect(() => {
    if (!workspaceId) {
      return
    }

    try {
      const unsub = subscribeChecklistItemsView(
        { workspaceId },
        (nextItems) => {
          setItems(nextItems)
        },
        (err) => {
          console.warn('[useWorkspaceChecklistItems] subscription error', err)
        },
      )

      return () => {
        unsub()
        setItems([])
      }
    } catch (err) {
      console.warn('[useWorkspaceChecklistItems] subscribe failed', err)
      return undefined
    }
  }, [workspaceId])

  return workspaceId ? items : []
}
